import {Component, OnInit, Input, Output, EventEmitter, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import {Subscription} from 'rxjs';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../services/auth.service";

@Component({
  selector: 'micro-objectGroup-picklist',
  templateUrl: './objectGroup-picklist.component.html'
})
export class ObjectGroupPicklistComponent implements OnChanges, OnDestroy {
  private request?: Subscription;
  @Input() companyId: any;
  all:any[];
  description:any;

  @Input()
  type:any;

  @Output()
  selectedItemsChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  selectedItems:string[];

  @Input()
  listMinSize: number = 10;

  onNgModelChange(e) {
    this.selectedItemsChange.emit(e);
  }

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient) {
  }

  reload() {
    this.request?.unsubscribe();
    this.all = [];
    if (!this.type) return;
    let params = new HttpParams().set('type', this.type);
    if (this.companyId) params = params.set('companyId', this.companyId);
    return this.request = this.http.get(`${this.env.e.url}/domain/objectGroups/all`, {params})
      .subscribe({next: data => this.all = data as any[], error: () => this.all = []});
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.companyId || changes.type) {
      this.reload();
    }
  }

  ngOnDestroy(): void {
    this.request?.unsubscribe();
  }
}
